import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const createCity = async (data: CreateCityReqT) =>
  axios.post(Routes.CREATE_CITY, data);

export const useCreateCity = () =>
  useMutation({
    mutationKey: [Keys.CREATE_CITY_MUT],
    mutationFn: createCity,
  });
